import { alertRequest, body } from "services/request";

const resource = "api/feedbacks";

const apply = (params: {}) => alertRequest(`${resource}/apply`, body(params));

export { apply };
